export default "__VITE_ASSET__c43271a2__"